import {
  HTTP_GETBUHEAD_FETCHING,
  HTTP_GETBUHEAD_SUCCESS,
  HTTP_GETBUHEAD_FAILED,
  server,
} from "src/Constants";
import { httpClient } from "src/utils/HttpClient";

export const setStateGetBuHeadToFetching = () => ({
  type: HTTP_GETBUHEAD_FETCHING,
});

export const setStateGetBuHeadToSuccess = (payload) => ({
  type: HTTP_GETBUHEAD_SUCCESS,
  payload,
});

export const setStateGetBuHeadToFailed = (payload) => ({
  type: HTTP_GETBUHEAD_FAILED,
});

export const getBuHead = (perid) => {
  return async (dispatch) => {
    dispatch(setStateGetBuHeadToFetching());
    try {
      const result = await httpClient.get(
        `${server.GETBUHEADLIST_URL}/${perid}`
      );

      dispatch(setStateGetBuHeadToSuccess(result.data));
    } catch (error) {
      dispatch(setStateGetBuHeadToFailed());
    }
  };
};
